import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, Typography, useTheme } from '@mui/material';
import { useLayoutEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';
// @ts-ignore: CSS module import without type declarations
import 'react-phone-input-2/lib/style.css';
import PhoneInputImport from 'react-phone-input-2';
import { ErrorWithIcon } from '../common/TextField/ErrorWithIcon';
const PhoneInput = PhoneInputImport.default ??
    PhoneInputImport;
export const PhoneInputMasking = ({ control, name, label, error, rules, disabled = false, bg = 'light', fetchCountryDetails, countryCode }) => {
    const theme = useTheme();
    const containerRef = useRef(null);
    const isLightColor = ['#00B6ED', '#FFDD00', '#76B82A'].includes(theme.palette.primary.main);
    const isGrey8 = bg === 'grey8' || bg === 'grey8Event';
    const borderRadius = bg === 'grey8Event' ? '12px' : bg === 'grey8' ? '14px' : '8px';
    const grey8BackgroundColor = isLightColor ? alpha('#9A9A98', 0.08) : theme.palette.common.grey8;
    const grey8BorderColor = isLightColor
        ? alpha('#9A9A98', 0.12)
        : alpha(theme.palette.grey[500], 0.12);
    const inputBackgroundColor = isGrey8 ? grey8BackgroundColor : 'transparent';
    const labelColor = isGrey8
        ? isLightColor
            ? theme.palette.common.grey.dark
            : theme.palette.grey[700]
        : disabled
            ? '#919EAB'
            : theme.palette.text.secondary;
    const inputColor = isGrey8 ? theme.palette.text.primary : disabled ? '#919EAB' : '#00244D';
    useLayoutEffect(() => {
        const flagButton = containerRef.current?.querySelector('.react-tel-input .selected-flag');
        if (flagButton) {
            flagButton.tabIndex = -1;
        }
    });
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field: { onChange, value } }) => (_jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(Box, { ref: containerRef, className: 'tel-input-container', sx: {
                        width: '100%',
                        '& .react-tel-input': { width: '100%' },
                        '& .react-tel-input *': { fontFamily: 'SuisseIntl' },
                        '& .react-tel-input .form-control': {
                            width: '100%',
                            transition: 'border 0.3s',
                            border: isGrey8 ? `1px solid ${grey8BorderColor}` : 'none',
                            borderColor: isGrey8 ? grey8BorderColor : 'transparent',
                            backgroundColor: inputBackgroundColor,
                            ...(isGrey8 && {
                                boxShadow: 'none',
                                '&:focus': {
                                    border: `1px solid ${grey8BorderColor}`,
                                    borderColor: grey8BorderColor,
                                    outline: 'none'
                                },
                                '&:hover': {
                                    backgroundColor: grey8BackgroundColor
                                }
                            }),
                            ...(!isGrey8 && {
                                '&:focus': {
                                    border: 'none !important',
                                    borderColor: 'transparent !important',
                                    outline: 'none'
                                }
                            })
                        },
                        '&:focus-within .react-tel-input .form-control': {
                            ...(isGrey8 && bg === 'grey8'
                                ? {
                                    border: `1px solid ${grey8BorderColor}`,
                                    borderColor: grey8BorderColor
                                }
                                : {
                                    border: 'none !important',
                                    borderColor: 'transparent !important'
                                })
                        },
                        '& .react-tel-input .country-list': {
                            position: 'absolute',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            zIndex: 1000000000,
                            borderRadius: '12px',
                            bottom: '100%',
                            transform: 'translateY(-8px)'
                        },
                        '& .react-tel-input .country-list .search-box': {
                            width: 'calc(100% - 34px)',
                            padding: '8px 12px',
                            borderRadius: '8px'
                        },
                        '& .react-tel-input .selected-flag': {
                            borderRadius: `${borderRadius} 0 0 ${borderRadius}`,
                            border: 'none !important',
                            backgroundColor: 'transparent !important'
                        },
                        '& .react-tel-input .flag-dropdown': {
                            borderRadius: `${borderRadius} 0 0 ${borderRadius}`,
                            border: 'none !important'
                        },
                        borderRadius: borderRadius
                    }, children: _jsxs(Box, { position: 'relative', borderRadius: borderRadius, children: [_jsx(Typography, { sx: {
                                    position: 'absolute',
                                    top: 6,
                                    left: 41,
                                    zIndex: 10
                                }, variant: 'caption', color: labelColor, children: label }), _jsx(PhoneInput, { country: countryCode ?? 'nl', value: value, onChange: (phone, country, _event, formattedValue) => {
                                    onChange(phone);
                                    fetchCountryDetails?.(country, formattedValue);
                                }, placeholder: '', inputStyle: {
                                    width: '100%',
                                    height: '53px',
                                    fontSize: '0.875rem',
                                    fontFamily: 'SuisseIntl',
                                    backgroundColor: inputBackgroundColor,
                                    paddingLeft: '40px',
                                    borderRadius: borderRadius,
                                    paddingTop: '25px',
                                    paddingBottom: '6px',
                                    color: inputColor,
                                    border: isGrey8 ? `1px solid ${grey8BorderColor}` : 'none',
                                    transition: 'border 0.3s',
                                    boxShadow: isGrey8 ? 'none' : undefined
                                }, buttonStyle: {
                                    backgroundColor: 'transparent',
                                    borderRight: 'none'
                                }, dropdownStyle: {
                                    width: 'max-content',
                                    maxHeight: '250px',
                                    overflowY: 'auto',
                                    zIndex: 1000000000
                                }, disabled: disabled, enableSearch: true, searchPlaceholder: 'Search country...', inputProps: {
                                    required: rules?.required?.value,
                                    'aria-label': label,
                                    tabIndex: 0
                                }, specialLabel: label, preferredCountries: ['nl', 'be', 'de', 'fr', 'at', 'ch'], masks: {
                                    nl: '. ........',
                                    be: '... .. .. ..',
                                    se: '.. ... .. ..',
                                    de: '... ........'
                                } }, countryCode ?? 'nl')] }) }), _jsx(ErrorWithIcon, { error: error })] })) }));
};
